import { createTheme, type Theme } from "@mui/material/styles";
import {
  tokensFor,
  type ThemeMode,
  RADIUS,
  FONT_FAMILY,
  BASE_FONT_SIZE,
} from "./tokens";

// The single MUI theme factory for both apps. Wrap each app root in
// <ThemeProvider theme={createAppTheme(mode)}> + <CssBaseline />.
export const createAppTheme = (mode: ThemeMode): Theme => {
  const t = tokensFor(mode);
  return createTheme({
    palette: {
      mode,
      primary: t.primary,
      secondary: t.secondary,
      success: { main: t.success },
      warning: { main: t.warning },
      error: { main: t.error },
      info: { main: t.info },
      text: t.text,
      background: t.background,
      divider: t.divider,
    },
    shape: { borderRadius: RADIUS },
    typography: {
      fontFamily: FONT_FAMILY,
      fontSize: BASE_FONT_SIZE,
      button: { textTransform: "none", fontWeight: 600 },
    },
    components: {
      // Give every outlined input (TextField, Select, DatePicker, Autocomplete —
      // all render .MuiOutlinedInput-root) a solid paper background so fields read
      // as white insets against the off-white page bg, instead of blending in.
      // Targets the outlined variant only: standard/filled inputs and the raw
      // <input> inline-edit cells in colored table rows stay transparent by design.
      // Disabled keeps a muted page-bg fill so it still reads as non-editable;
      // hover/focus only touch the border, so the static bg doesn't fight them.
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            backgroundColor: t.background.paper,
            "&.Mui-disabled": { backgroundColor: t.background.default },
          },
        },
      },
    },
  });
};
